<template>
    <div class="page">
        <p>
            {{ date }}
        </p>
        <p>
            <b>{{ userStore.user.firstname }} {{ userStore.user.lastname }}</b>
            <br />
            <b>{{ userStore.user.address }}</b>
            <br />
            <b>{{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}</b>
        </p>
        <p>
            <b>{{ creditBureau.address_name }}</b>
            <br />
            <b>{{ address.street }}</b>
            <br />
            <b>{{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}</b>
        </p>
        <p>
            <b>RE: {{ userStore.user.ssn }}</b>
        </p>
        <p style="text-align: center;" class="letter-content">
            <b>NOTICE TO PRINCIPAL IS NOTICE TO AGENT AND NOTICE TO AGENT IS NOTICE TO PRINCIPAL</b>
        </p>
        <p class="letter-content">
            To Whom It May Concern,
        </p>
        <p class="letter-content">
            <b>
                Please be advised this is my THIRD WRITTEN REQUEST and FINAL WARNING that I fully intend to pursue litigation in accordance with the FCRA to enforce my rights and seek relief and recover all monetary damages that I may be entitled to under 15 USC 1681n and 15 USC 1681o regarding your continued willful and negligent noncompliance.
            </b>
        </p>
        <p class="letter-content">
            Despite two written requests, the unverified items listed below still remain on my credit report in violation of Federal Law. You are required under the FCRA to have a copy of the original creditors documentation on file to verify that this information is mine and is correct. In the results of your first investigation and subsequent reinvestigation, you stated in writing that you <b>“verified”</b> that these items are being <b>“reported correctly” ?</b>Who verified these accounts? You have <b>NOT</b> provided me a copy of ANY original documentation ( a consumer contract with my signature on it)  as required under <b>15 USC 1681g (a)(1) &  15 USC 1681i (a)(1)(A).</b> 
        </p>
        <p class="letter-content">
            Furthermore, you have failed to provide the method of verification as required under <b>15 USC1681i (a) (7).</b>   Please be advised that under <b>15 USC1681i (5)(A)</b> of the FCRA - you are required to <b><i>“…promptly DELETE all information which cannot be verified.” </i></b>
        </p>
        <p class="letter-content">
            The law is very clear as to the Civil liability and the remedy available to me <b>15 USC 1681n & 15 USC 1681o</b>) if you fail to comply with Federal Law. I am a litigious consumer and fully intend on pursuing litigation in this matter to enforce my rights under the FCRA.    
        </p>
        <p class="letter-content">
            <b>I demand the following accounts be verified or deleted immediately.</b>
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number 
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
            </strong>
            <template v-if="creditor.reason">
                <br />
                {{ creditor.reason }}
            </template>
        </p>
        <p class="letter-content">
            In addition, please remove all non-account holding inquiries over 30 days old. Also, please add a promotional suppression to my credit file.
        </p>
        <p class="letter-content">
            Under federal law, you have thirty (30) days to complete your re-investigation. Be advised that the description of the procedure used to determine the accuracy and completeness of the information is hereby requested as well, to be provided within fifteen (15) days of the completion of your re-investigation.
        </p>
        <p style="page-break-after: always;">
            Thank you, <br> <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = lodash.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                address,
            };
        }
    };
</script>
